// extracted by mini-css-extract-plugin
export default {"header":"header_header__tYCnM","brand-contact":"header_brand-contact__BHPCh","color":"header_color__WmFSU","brand-logo":"header_brand-logo__Ca-Cz"};